//Common Loader of the system
import React from "react";
import "./layout.css";
import { Spin } from "antd";

export default function Loader(props) {
  const { size, inline } = props;
  const spinSize = size || "large";
  // large = full-page gate (sidebar auth, route suspense); default/small = in-panel
  const isInline = inline ?? spinSize !== "large";

  return (
    <div
      className={`loader${isInline ? " loader--inline" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <Spin tip="Loading..." size={spinSize} />
    </div>
  );
}
